var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 1C0 0.447715 0.447715 0 1 0H3C3.55228 0 4 0.447715 4 1V15C4 15.5523 3.55228 16 3 16H1C0.447715 16 0 15.5523 0 15V1ZM12 1C12 0.447715 12.4477 0 13 0H15C15.5523 0 16 0.447715 16 1V15C16 15.5523 15.5523 16 15 16H13C12.4477 16 12 15.5523 12 15V1ZM7 0C6.44772 0 6 0.447715 6 1V15C6 15.5523 6.44772 16 7 16H9C9.55229 16 10 15.5523 10 15V1C10 0.447715 9.55229 0 9 0H7Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.97a7e2e30a0b1f9dd80dc79ca4d2e361.svg";
export { ForwardRef as ReactComponent };